export default [
  {
    path: '/imovel/:imovelId/funcionarios',
    name: 'ImovelFuncionario',
    component: () => import('./ImovelFuncionario'),
    meta: {
      domain: 'Imovel',
      sidebar: false,
      icon: 'keyboard_backspace',
      title: 'Funcionários vinculados',
      routerBack: '/imovel',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Imovel/Funcionario/ImovelFuncionarioRouter.js